//Длительность анимации в мс
export const DURATION = 300;
